import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import IconButton from '@material-ui/core/IconButton'

import green from '@material-ui/core/colors/green'
import amber from '@material-ui/core/colors/amber'

import selectors from 'store/selectors'
import settings from 'settings'
import snackbarActions from 'store/modules/snackbar'

const CloseIcon = settings.icons.close
const variantIcon = {
  success: settings.icons.success,
  warning: settings.icons.warning,
  error: settings.icons.error,
  info: settings.icons.info,
}

const useStyles = makeStyles(theme => ({
  fullHeight: {
    height: '100%'
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  close: {
    padding: theme.spacing() / 2,
  },
  success: {
    backgroundColor: green[600],
  },
  warning: {
    backgroundColor: amber[700],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  margin: {
    margin: theme.spacing(),
  },
}))

const SnackbarWrapper = ({
  children,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const open = useSelector(selectors.snackbar.open)
  const text = useSelector(selectors.snackbar.text)
  const type = useSelector(selectors.snackbar.type)
  const onClose = () => dispatch(snackbarActions.onClose())

  const Icon = variantIcon[type]

  return (
    <div className={ classes.fullHeight }>
      { children }
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={ open }
        autoHideDuration={ settings.snackbarAutoHide }
        onClose={ onClose }
      >
        <SnackbarContent
          className={ classNames(classes[type], classes.margin) }
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className={ classes.message }>
              { 
                Icon && (
                  <Icon 
                    className={ classNames(classes.icon, classes.iconVariant) }
                  />
                )
              }
              { text }
            </span>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={ classes.close }
              onClick={ onClose }
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Snackbar>
    </div>
  )
}

export default SnackbarWrapper